import * as api from '../api/export';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const FETCH_OWNER_AGENT_EXPORT_LOG = createRequestTypes(
  'EXPORT/FETCH_OWNER_AGENT_EXPORT_LOG',
);

export const OWNER_AGENT_EXPORT_LOG_LAUNCH = createRequestTypes(
  'EXPORT/OWNER_AGENT_EXPORT_LOG_LAUNCH',
);

export const DOWNLOAD_FILE_WITH_URL = createRequestTypes(
  'EXPORT/DOWNLOAD_FILE_WITH_URL',
);

export const DOWNLOAD_FILE = createRequestTypes('EXPORT/DOWNLOAD_FILE');

export const DOWNLOAD_REPORT_FILE = createRequestTypes(
  'EXPORT/DOWNLOAD_REPORT_FILE',
);

export const DOWNLOAD_S3_FILE = createRequestTypes('EXPORT/DOWNLOAD_S3_FILE');

export const DOWNLOAD_S3_FILE_JSON = createRequestTypes(
  'EXPORT/DOWNLOAD_S3_FILE_JSON',
);

export const FETCH_APPRAISAL_EXPORT = createRequestTypes(
  'EXPORT/FETCH_APPRAISAL_EXPORT',
);

export const FETCH_APPRAISAL_EXPORT_LOG = createRequestTypes(
  'EXPORT/FETCH_APPRAISAL_EXPORT_LOG',
);

export const FETCH_APPRAISAL_EXPORT_LOG_ERROR_SUMMARY = createRequestTypes(
  'EXPORT/FETCH_APPRAISAL_EXPORT_LOG_ERROR_SUMMARY',
);

export const FETCH_APPRAISAL_EXPORT_LOG_ERROR_DETAIL = createRequestTypes(
  'EXPORT/FETCH_APPRAISAL_EXPORT_LOG_ERROR_DETAIL',
);

export const FETCH_PTD = createRequestTypes('EXPORT/FETCH_PTD');

export const FETCH_SINGLE_PTD = createRequestTypes('EXPORT/FETCH_SINGLE_PTD');

export const CAPTURE_PTD_TOTALS = createRequestTypes(
  'EXPORT/CAPTURE_PTD_TOTALS',
);

export const FETCH_PTD_VALIDATION_ERROR_SUMMARY = createRequestTypes(
  'EXPORT/FETCH_PTD_VALIDATION_ERROR_SUMMARY',
);

export const FETCH_PTD_VALIDATION_ERROR_DETAIL = createRequestTypes(
  'EXPORT/FETCH_PTD_VALIDATION_ERROR_DETAIL',
);

export const PREVALIDATE_PTD = createRequestTypes('EXPORT/PREVALIDATE_PTD');

export const GENERATE_PTD_RUN = createRequestTypes('EXPORT/GENERATE_PTD_RUN');

export const POSTVALIDATE_PTD = createRequestTypes('EXPORT/POSTVALIDATE_PTD');

export const FETCH_ROLL_CORRECTIONS = createRequestTypes(
  'EXPORT/FETCH_ROLL_CORRECTIONS',
);

export const EXPORT_APPRAISAL = createRequestTypes('EXPORT/EXPORT_APPRAISAL');
export const EXPORT_APPRAISAL_JSON = createRequestTypes(
  'EXPORT/EXPORT_APPRAISAL_JSON',
);

export const VALIDATE_QUERY = createRequestTypes('EXPORT/VALIDATE_QUERY');

export const VALIDATE_QUERY_JSON = createRequestTypes(
  'EXPORT/VALIDATE_QUERY_JSON',
);

export const FETCH_ERROR_SUMMARY = createRequestTypes(
  'EXPORT/FETCH_ERROR_SUMMARY',
);

export const FETCH_ERROR_DETAIL = createRequestTypes(
  'EXPORT/FETCH_ERROR_DETAIL',
);

export const EXPORT_EARS_RUN = createRequestTypes(`EXPORT/EXPORT_EARS_RUN`);

export const DOWNLOAD_EARS = createRequestTypes(`EXPORT/DOWNLOAD_EARS`);

export const CREATE_EARS = createRequestTypes(`EXPORT/CREATE_EARS`);

export const FETCH_PROPERTY_TYPES = createRequestTypes(
  `EXPORT/FETCH_PROPERTY_TYPES`,
);

export const FETCH_EXPORT_FORMATS = createRequestTypes(
  `EXPORT/FETCH_EXPORT_FORMATS`,
);

export const FETCH_APPRAISAL_EXPORT_JSON = createRequestTypes(
  'EXPORT/FETCH_APPRAISAL_EXPORT_JSON',
);

export const FETCH_APPRAISAL_EXPORT_JSON_LOG = createRequestTypes(
  'EXPORT/FETCH_APPRAISAL_EXPORT_JSON_LOG',
);

export const fetchOwnerAgentExportLog = makeApiActionCreatorV3(
  api.fetchOwnerAgentExportLog,
  FETCH_OWNER_AGENT_EXPORT_LOG[START],
  FETCH_OWNER_AGENT_EXPORT_LOG[SUCCESS],
  FETCH_OWNER_AGENT_EXPORT_LOG[ERROR],
);

export const ownerAgentExportLogLaunch = makeApiActionCreatorV3(
  api.ownerAgentExportLogLaunch,
  OWNER_AGENT_EXPORT_LOG_LAUNCH[START],
  OWNER_AGENT_EXPORT_LOG_LAUNCH[SUCCESS],
  OWNER_AGENT_EXPORT_LOG_LAUNCH[ERROR],
);

export const downloadFileWithURL = makeApiActionCreatorV3(
  api.downloadFileWithURL,
  DOWNLOAD_FILE_WITH_URL[START],
  DOWNLOAD_FILE_WITH_URL[SUCCESS],
  DOWNLOAD_FILE_WITH_URL[ERROR],
);

export const downloadFile = makeApiActionCreatorV3(
  api.downloadFile,
  DOWNLOAD_FILE[START],
  DOWNLOAD_FILE[SUCCESS],
  DOWNLOAD_FILE[ERROR],
);

export const downloadReportFile = makeApiActionCreatorV3(
  api.downloadReportFile,
  DOWNLOAD_REPORT_FILE[START],
  DOWNLOAD_REPORT_FILE[SUCCESS],
  DOWNLOAD_REPORT_FILE[ERROR],
);

export const downloadS3File = makeApiActionCreatorV3(
  api.downloadS3File,
  DOWNLOAD_S3_FILE[START],
  DOWNLOAD_S3_FILE[SUCCESS],
  DOWNLOAD_S3_FILE[ERROR],
);

export const fetchAppraisalExport = makeApiActionCreatorV3(
  api.fetchAppraisalExport,
  FETCH_APPRAISAL_EXPORT[START],
  FETCH_APPRAISAL_EXPORT[SUCCESS],
  FETCH_APPRAISAL_EXPORT[ERROR],
);

export const fetchAppraisalExportLog = makeApiActionCreatorV3(
  api.fetchAppraisalExportLog,
  FETCH_APPRAISAL_EXPORT_LOG[START],
  FETCH_APPRAISAL_EXPORT_LOG[SUCCESS],
  FETCH_APPRAISAL_EXPORT_LOG[ERROR],
);

export const fetchAppraisalExportJSON = makeApiActionCreatorV3(
  api.fetchAppraisalExportJSON,
  FETCH_APPRAISAL_EXPORT_JSON[START],
  FETCH_APPRAISAL_EXPORT_JSON[SUCCESS],
  FETCH_APPRAISAL_EXPORT_JSON[ERROR],
);

export const fetchAppraisalExportJSONLog = makeApiActionCreatorV3(
  api.fetchAppraisalExportJSONLog,
  FETCH_APPRAISAL_EXPORT_JSON_LOG[START],
  FETCH_APPRAISAL_EXPORT_JSON_LOG[SUCCESS],
  FETCH_APPRAISAL_EXPORT_JSON_LOG[ERROR],
);

export const fetchAppraisalExportLogErrorSummary = makeApiActionCreatorV3(
  api.fetchAppraisalExportLogErrorSummary,
  FETCH_APPRAISAL_EXPORT_LOG_ERROR_SUMMARY[START],
  FETCH_APPRAISAL_EXPORT_LOG_ERROR_SUMMARY[SUCCESS],
  FETCH_APPRAISAL_EXPORT_LOG_ERROR_SUMMARY[ERROR],
);

export const fetchAppraisalExportLogErrorDetail = makeApiActionCreatorV3(
  api.fetchAppraisalExportLogErrorDetail,
  FETCH_APPRAISAL_EXPORT_LOG_ERROR_DETAIL[START],
  FETCH_APPRAISAL_EXPORT_LOG_ERROR_DETAIL[SUCCESS],
  FETCH_APPRAISAL_EXPORT_LOG_ERROR_DETAIL[ERROR],
);

export const fetchRollCorrections = makeApiActionCreatorV3(
  api.fetchRollCorrections,
  FETCH_ROLL_CORRECTIONS[START],
  FETCH_ROLL_CORRECTIONS[SUCCESS],
  FETCH_ROLL_CORRECTIONS[ERROR],
);

export const exportAppraisal = makeApiActionCreatorV3(
  api.exportAppraisal,
  EXPORT_APPRAISAL[START],
  EXPORT_APPRAISAL[SUCCESS],
  EXPORT_APPRAISAL[ERROR],
);

export const exportAppraisalJSON = makeApiActionCreatorV3(
  api.exportAppraisalJSON,
  EXPORT_APPRAISAL_JSON[START],
  EXPORT_APPRAISAL_JSON[SUCCESS],
  EXPORT_APPRAISAL_JSON[ERROR],
);

export const validateQuery = makeApiActionCreatorV3(
  api.validateQuery,
  VALIDATE_QUERY[START],
  VALIDATE_QUERY[SUCCESS],
  VALIDATE_QUERY[ERROR],
);

export const validateQueryJSON = makeApiActionCreatorV3(
  api.validateQueryJSON,
  VALIDATE_QUERY_JSON[START],
  VALIDATE_QUERY_JSON[SUCCESS],
  VALIDATE_QUERY_JSON[ERROR],
);

export const downloadS3FileJSON = makeApiActionCreatorV3(
  api.downloadS3FileJSON,
  DOWNLOAD_S3_FILE_JSON[START],
  DOWNLOAD_S3_FILE_JSON[SUCCESS],
  DOWNLOAD_S3_FILE_JSON[ERROR],
);

export const fetchPTD = makeApiActionCreatorV3(
  api.fetchPTD,
  FETCH_PTD[START],
  FETCH_PTD[SUCCESS],
  FETCH_PTD[ERROR],
);

export const fetchSinglePTD = makeApiActionCreatorV3(
  api.fetchSinglePTD,
  FETCH_SINGLE_PTD[START],
  FETCH_SINGLE_PTD[SUCCESS],
  FETCH_SINGLE_PTD[ERROR],
);

export const captureTotals = makeApiActionCreatorV3(
  api.captureTotals,
  CAPTURE_PTD_TOTALS[START],
  CAPTURE_PTD_TOTALS[SUCCESS],
  CAPTURE_PTD_TOTALS[ERROR],
);

export const fetchValidationErrorSummary = makeApiActionCreatorV3(
  api.fetchValidationErrorSummary,
  FETCH_PTD_VALIDATION_ERROR_SUMMARY[START],
  FETCH_PTD_VALIDATION_ERROR_SUMMARY[SUCCESS],
  FETCH_PTD_VALIDATION_ERROR_SUMMARY[ERROR],
);

export const fetchValidationErrorDetail = makeApiActionCreatorV3(
  api.fetchValidationErrorDetail,
  FETCH_PTD_VALIDATION_ERROR_DETAIL[START],
  FETCH_PTD_VALIDATION_ERROR_DETAIL[SUCCESS],
  FETCH_PTD_VALIDATION_ERROR_DETAIL[ERROR],
);

export const preValidate = makeApiActionCreatorV3(
  api.preValidate,
  PREVALIDATE_PTD[START],
  PREVALIDATE_PTD[SUCCESS],
  PREVALIDATE_PTD[ERROR],
);

export const generatePTDRun = makeApiActionCreatorV3(
  api.generatePTDRun,
  GENERATE_PTD_RUN[START],
  GENERATE_PTD_RUN[SUCCESS],
  GENERATE_PTD_RUN[ERROR],
);

export const postValidate = makeApiActionCreatorV3(
  api.postValidate,
  POSTVALIDATE_PTD[START],
  POSTVALIDATE_PTD[SUCCESS],
  POSTVALIDATE_PTD[ERROR],
);

export const fetchErrorSummary = makeApiActionCreatorV3(
  api.fetchErrorSummary,
  FETCH_ERROR_SUMMARY[START],
  FETCH_ERROR_SUMMARY[SUCCESS],
  FETCH_ERROR_SUMMARY[ERROR],
);

export const fetchErrorDetail = makeApiActionCreatorV3(
  api.fetchErrorDetail,
  FETCH_ERROR_DETAIL[START],
  FETCH_ERROR_DETAIL[SUCCESS],
  FETCH_ERROR_DETAIL[ERROR],
);

export const exportEarsRun = makeApiActionCreatorV3(
  api.exportEarsRun,
  EXPORT_EARS_RUN[START],
  EXPORT_EARS_RUN[SUCCESS],
  EXPORT_EARS_RUN[ERROR],
);

export const downloadEars = makeApiActionCreatorV3(
  api.downloadEars,
  DOWNLOAD_EARS[START],
  DOWNLOAD_EARS[SUCCESS],
  DOWNLOAD_EARS[ERROR],
);

export const createEars = makeApiActionCreatorV3(
  api.createEars,
  CREATE_EARS[START],
  CREATE_EARS[SUCCESS],
  CREATE_EARS[ERROR],
);

export const fetchPropertyTypes = makeApiActionCreatorV3(
  api.fetchPropertyTypes,
  FETCH_PROPERTY_TYPES[START],
  FETCH_PROPERTY_TYPES[SUCCESS],
  FETCH_PROPERTY_TYPES[ERROR],
);

export const fetchExportFormats = makeApiActionCreatorV3(
  api.fetchExportFormats,
  FETCH_EXPORT_FORMATS[START],
  FETCH_EXPORT_FORMATS[SUCCESS],
  FETCH_EXPORT_FORMATS[ERROR],
);

export const CREATE_EXPORT_APPRAISAL_BETA = createRequestTypes(
  `EXPORT/CREATE_EXPORT_APPRAISAL_BETA`,
);

export const createExportAppraisalBeta = makeApiActionCreatorV3(
  api.createExportAppraisalBeta,
  CREATE_EXPORT_APPRAISAL_BETA[START],
  CREATE_EXPORT_APPRAISAL_BETA[SUCCESS],
  CREATE_EXPORT_APPRAISAL_BETA[ERROR],
);

export const SET_EXPORT_APPRAISAL_PARAM = createRequestTypes(
  `EXPORT/SET_EXPORT_APPRAISAL_PARAM`,
);

export const setExportAppraisalParam = makeApiActionCreatorV3(
  api.setExportAppraisalParam,
  SET_EXPORT_APPRAISAL_PARAM[START],
  SET_EXPORT_APPRAISAL_PARAM[SUCCESS],
  SET_EXPORT_APPRAISAL_PARAM[ERROR],
);

export const START_EXPORT_PROCESS_PREPDATA = createRequestTypes(
  `EXPORT/START_EXPORT_PROCESS_PREPDATA`,
);

export const startExportProcessPreData = makeApiActionCreatorV3(
  api.startExportProcessPreData,
  START_EXPORT_PROCESS_PREPDATA[START],
  START_EXPORT_PROCESS_PREPDATA[SUCCESS],
  START_EXPORT_PROCESS_PREPDATA[ERROR],
);

export const START_EXPORT_PROCESS_EXPORTDATA = createRequestTypes(
  `EXPORT/START_EXPORT_PROCESS_PREPDATA`,
);

export const startExportProcessExportData = makeApiActionCreatorV3(
  api.startExportProcessExportData,
  START_EXPORT_PROCESS_EXPORTDATA[START],
  START_EXPORT_PROCESS_EXPORTDATA[SUCCESS],
  START_EXPORT_PROCESS_EXPORTDATA[ERROR],
);

export const FETCH_APPRAISAL_BETA_EXPORT = createRequestTypes(
  `EXPORT/FETCH_APPRAISAL_BETA_EXPORT`,
);

export const fetchAppraisalBetaExportList = makeApiActionCreatorV3(
  api.fetchAppraisalBetaExportList,
  FETCH_APPRAISAL_BETA_EXPORT[START],
  FETCH_APPRAISAL_BETA_EXPORT[SUCCESS],
  FETCH_APPRAISAL_BETA_EXPORT[ERROR],
);

export const FETCH_APPRAISAL_BETA_RUN_LOG = createRequestTypes(
  `EXPORT/FETCH_APPRAISAL_BETA_RUN_LOG`,
);

export const fetchAppraisalBetaRunLog = makeApiActionCreatorV3(
  api.fetchAppraisalBetaRunLog,
  FETCH_APPRAISAL_BETA_RUN_LOG[START],
  FETCH_APPRAISAL_BETA_RUN_LOG[SUCCESS],
  FETCH_APPRAISAL_BETA_RUN_LOG[ERROR],
);

export const VALIDATE_EXPORT_QUERY = createRequestTypes(
  `EXPORT/VALIDATE_EXPORT_QUERY`,
);

export const validateExportQuery = makeApiActionCreatorV3(
  api.validateExportQuery,
  VALIDATE_EXPORT_QUERY[START],
  VALIDATE_EXPORT_QUERY[SUCCESS],
  VALIDATE_EXPORT_QUERY[ERROR],
);

export const DOWNLOAD_EXPORT_FILE = createRequestTypes(
  `EXPORT/DOWNLOAD_EXPORT_FILE`,
);

export const downloadExportFile = makeApiActionCreatorV3(
  api.downloadExportFile,
  DOWNLOAD_EXPORT_FILE[START],
  DOWNLOAD_EXPORT_FILE[SUCCESS],
  DOWNLOAD_EXPORT_FILE[ERROR],
);

export const DOWNLOAD_PRESIGNED_EXPORT_FILE = createRequestTypes(
  `EXPORT/DOWNLOAD_PRESIGNED_EXPORT_FILE`,
);

export const downloadPresignedExportFile = makeApiActionCreatorV3(
  api.downloadPresignedExportFile,
  DOWNLOAD_PRESIGNED_EXPORT_FILE[START],
  DOWNLOAD_PRESIGNED_EXPORT_FILE[SUCCESS],
  DOWNLOAD_PRESIGNED_EXPORT_FILE[ERROR],
);

export const GET_APPRAISAL_BETA_EXPORT_RUN = createRequestTypes(
  `EXPORT/GET_APPRAISAL_BETA_EXPORT_RUN`,
);

export const getAppraisalBetaExportRun = makeApiActionCreatorV3(
  api.getAppraisalBetaExportRun,
  GET_APPRAISAL_BETA_EXPORT_RUN[START],
  GET_APPRAISAL_BETA_EXPORT_RUN[SUCCESS],
  GET_APPRAISAL_BETA_EXPORT_RUN[ERROR],
);

export const FETCH_BPP_RENDITIONS_EXPORTS = createRequestTypes(
  `EXPORT/FETCH_BPP_RENDITIONS_EXPORTS`,
);

export const fetchBppRenditionsExports = makeApiActionCreatorV3(
  api.fetchBppRenditionsExports,
  FETCH_BPP_RENDITIONS_EXPORTS[START],
  FETCH_BPP_RENDITIONS_EXPORTS[SUCCESS],
  FETCH_BPP_RENDITIONS_EXPORTS[ERROR],
);

export const CREATE_BPP_RENDITIONS_EXPORT = createRequestTypes(`EXPORT/CREATE_BPP_RENDITIONS_EXPORT`);

export const createBppRenditionExport = makeApiActionCreatorV3(
  api.createBppRenditionExport,
  CREATE_BPP_RENDITIONS_EXPORT[START],
  CREATE_BPP_RENDITIONS_EXPORT[SUCCESS],
  CREATE_BPP_RENDITIONS_EXPORT[ERROR],
);

export const FETCH_BPP_RENDITIONS_EXPORT = createRequestTypes(
  `EXPORT/FETCH_BPP_RENDITIONS_EXPORT`,
);

export const fetchBppRenditionsExport = makeApiActionCreatorV3(
  api.fetchBppRenditionsExport,
  FETCH_BPP_RENDITIONS_EXPORT[START],
  FETCH_BPP_RENDITIONS_EXPORT[SUCCESS],
  FETCH_BPP_RENDITIONS_EXPORT[ERROR],
);

export const FETCH_PROPERTY_FORM_OPTIONS_EVENTS = createRequestTypes(
  'EXPORT/FETCH_PROPERTY_FORM_OPTIONS_EVENTS',
);

export const fetchPropertyFormOptionsEvents = makeApiActionCreatorV3(
  api.fetchPropertyFormOptionsEvents,
  FETCH_PROPERTY_FORM_OPTIONS_EVENTS[START],
  FETCH_PROPERTY_FORM_OPTIONS_EVENTS[SUCCESS],
  FETCH_PROPERTY_FORM_OPTIONS_EVENTS[ERROR],
);

export const DELETE_OWNER_AGENT_EXPORT_LOG = createRequestTypes(
  'EXPORT/DELETE_OWNER_AGENT_EXPORT_LOG',
);

export const deleteOwnerAgentExportLog = makeApiActionCreatorV3(
  api.deleteOwnerAgentExportLog,
  DELETE_OWNER_AGENT_EXPORT_LOG[START],
  DELETE_OWNER_AGENT_EXPORT_LOG[SUCCESS],
  DELETE_OWNER_AGENT_EXPORT_LOG[ERROR],
);